import { createSelector } from "reselect";
import { FormState } from "redux-form";

import { RootState } from "../../store/types";
import { Step5State } from "./reducer";
import * as constants from "./constants";
import { form } from "../../store/selectors";
import { SuppInfoFormValues } from "./components/SuppInfoForm";

export const step5 = (state: RootState): Step5State => state.step5;

const currSuppForm = createSelector(
  form,
  state =>
    (state[constants.SUPP_INFO_FORM] as FormState) ||
    ({ values: {} } as FormState),
);

export const currFormValues = createSelector(
  currSuppForm,
  state => state.values as SuppInfoFormValues | undefined,
);

export const savedFormValues = createSelector(
  step5,
  state => state.suppFormValues,
);

export const suppFormValues = createSelector(
  currFormValues,
  savedFormValues,
  (current, saved) =>
    (Object.keys(current || {}).length ? current : saved) as SuppInfoFormValues,
);

export const isSubmitting = createSelector(step5, state => state.isSubmitting);
export const submitError = createSelector(step5, state => state.submitError);

// Force payment upfront if cost policy N/A or cost policy's min_payment_upfront specified
const summary = (state: RootState) => state.wizardSummary;
const costPolicy = createSelector(summary, state => state.costPolicy);

export const isPaymentUpfrontForced = createSelector(
  costPolicy,
  policy => (policy == null ? true : +policy.min_payment_upfront !== 0),
);



// WEBPACK FOOTER //
// ./src/routes/Step5/selectors.ts